import { basicEnum } from "./base";

export const NotificationTypeEnum = basicEnum([
    {
        label: "Customer Survey Technician",
        value: "CST",
    },
    {
        label: "Customer Survey CC",
        value: "CSC",
    },
    {
        label: "Customer Installation Technician",
        value: "CIT",
    },
    {
        label: "Customer Installation CC",
        value: "CIC",
    },
    {
        label: "Reseller Survey Technician",
        value: "RST",
    },
    {
        label: "Reseller Survey CC",
        value: "RSC",
    },
    {
        label: "Reseller Installation Technician",
        value: "RIT",
    },
    {
        label: "Reseller Installation CC",
        value: "RIC",
    },
    {
        label: "Customer Direct Message",
        value: "CustomerDirectMessage",
    },
]);

export namespace NotificationTypeEnum {
    export type Labels = (typeof NotificationTypeEnum)["labels"][number];
    export type Values = (typeof NotificationTypeEnum)["values"][number];
}
